import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import { getRepsByOfficeId } from "../../api-calls/projectDataService";
import "../../css/ProjectModal.scss";
import { ProjectStatusFilterBy } from "../../interfaces/interfaces";
import { isEmptyArray } from "../../utilities/helpers";
import { addNotification } from "../../api-utilities/notification-tools";
import { callPostEndpoint } from "../../api-calls/readApiService";

// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
  reduxProjectManagement: any;
}
// local state
interface IState {
  individualErrors: any[];
  searchByEmail: string;
  showResults: boolean;
  enableTransfer:boolean;
  userList: any[];
  specmateJobCount: any;
  showSpinner: boolean;
}

class TransferProjectModal extends React.Component<IProps, IState> {
  public state: IState = {
    individualErrors: [],
    searchByEmail: "",
    showResults: false,
    enableTransfer:false,
    userList: [],
    specmateJobCount: null, 
    showSpinner: false
  };

 
  private searchUsersKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      this.searchUsers();
    }
  }
  private async searchUsers() {
    if (this.state.searchByEmail !== "") {
        this.setState({showResults:false, showSpinner:true});
        let request = {
          email: this.state.searchByEmail
        };
        let result = await callPostEndpoint("dataapi/searchUsersByEmail", request);
        if (result.success) {
          //console.log(result.data);
          if(result.data.hasError){
            const notification = {
              id: "searchUsersError",
              notificationType: "error",
              title: "Error",
              content: <div className="nf-div">SearchUsers {result.data.errorMessage}</div>
            };
            addNotification(notification);

            this.setState({ showSpinner:false,
              showResults: false, 
              enableTransfer:false, 
              userList: [], 
              specmateJobCount: null });
          }
          else{
          let enableTransfer = result.data.userList.length == 1 ? true : false;
          this.setState({ showSpinner:false,
                          showResults: true, 
                          enableTransfer:enableTransfer, 
                          userList: result.data.userList, 
                          specmateJobCount: result.data.specmateJobCount });
          }
        }
        else{
              const notification = {
                  id: "searchUsersError",
                  notificationType: "error",
                  title: "Error",
                  content: <div className="nf-div">SearchUsers {result.data}</div>
                };
                addNotification(notification);

                this.setState({ showSpinner:false,
                  showResults: false, 
                  enableTransfer:false, 
                  userList: [], 
                  specmateJobCount: null });
        }
      } 
    } 

    private getUserList(){
      return this.state.userList.map((item: any, index: number) => (
        <div key={index}>{this.state.userList[0].firstName} {this.state.userList[0].lastName}</div>
        ));
    }

  //This will trigger the componentDidUpdate method on ProjectManagement.tsx
  private userResponse(response: string) {
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: response });
    if (response === "ok" && this.state.userList.length == 1) {
      this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", {
        selectedUserId: this.state.userList[0].loginId
      });
    }
    if (response === "cancel") {
      this.props.updateRedux("UPDATE_PROJECT_MANAGEMENT", { selectedUserId: "" });
    }
  }
  //------------------------------------------------------------------------------
  public render() {
    let userList = this.getUserList();
    return (
      <div className="newProject">
        <div className="proj-modal-header">Transfer Job</div>

        <div className="InputRow">
           <div className="project-search-title">
            Find User:
            <input
              className="input-180"
              type="text"
              placeholder="User email..."
              value={this.state.searchByEmail}
              onChange={(event) => this.setState({ searchByEmail: event.currentTarget.value, showResults: false, enableTransfer:false, showSpinner:false })}
              onKeyDown={(event) => this.searchUsersKeyDown(event)}
            />
            <div className="proj-search-btn" onClick={() => this.searchUsers()}>
              <div className="proj-search-symbol">&#9906;</div>
            </div>
            </div>
        </div>

        <div className="acc-spacer"></div>
        <div className="acc-spacer"></div>

        {this.state.showResults ? (
          <div className="transfer-results">
             {this.state.userList.length == 0  ? (
              <>
              <div className="transfer-result-left">            
                <div className="transfer-notfound-text">Not Found</div>
                <div className="redx-icon"></div>
                </div>
                <div className="transfer-result-right">
                  <div>{this.state.searchByEmail}</div>
                  <div className="acc-spacer"></div>
                  <div>This user was not found in Specmate. Users must log into Specmate at least once to create an account.</div>
                </div>
              
              <div className="proj-transfer-warning">
               
              </div>
            </>
          ) : null}

          {this.state.userList.length == 1  ? (
              <>
              <div className="transfer-result-left">            
                <div className="transfer-found-text">Found</div>
                <div className="green-checkmark"></div>
              </div>
              <div className="transfer-result-right">
                <div>{this.state.userList[0].firstName} {this.state.userList[0].lastName}</div>
                <div>{this.state.searchByEmail}</div>
                <div>Specmate Jobs: {this.state.specmateJobCount}</div>
              </div>
              <div className="proj-transfer-warning">
                Warning: Job will be transferred to {this.state.userList[0].firstName} {this.state.userList[0].lastName}.  
                You will no longer have access to it in Specmate.
                  {this.state.individualErrors}
              </div>
            </>
          ) : null}

          {this.state.userList.length > 1  ? (
              <>
              <div className="transfer-result-left">            
                <div className="transfer-found-text"></div>
                <div className="warning-icon"></div>
              </div>
              <div className="transfer-result-right">
                <div>Duplicate user records found</div>
                {userList}
              </div>
              <div className="proj-transfer-warning">
                Multiple user records were found matching the same email address.  Please contact Innovent to remove the duplicates.
                  {this.state.individualErrors}
              </div>
            </>
          ) : null}
        </div>
        ): null}


        {this.state.enableTransfer ? (
       
        <div className="button-container">   
          <div className="proj-create-btn" onClick={() => this.userResponse("ok")}>
            Transfer
          </div>
       
          <div className="proj-cancel-btn" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
   
        ) : (
          <>
          {this.state.showSpinner ? (
            <div className="button-container">    
              <div className="transfer-spinner"></div>
              <div className="acc-spacer"></div>
              <div className="acc-spacer"></div>
            </div>
          ) : null }    
        <div className="button-container">    
          <div className="proj-cancel-btn proj-cancel-btn-centered" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
        </>
        ) }
       
      </div>
    );
  }

}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxProjectManagement: state.reduxProjectManagement,
    reduxModals: state.reduxModals
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TransferProjectModal);
